import React, { Dispatch, SetStateAction } from 'react';
import {
  Pressable, ScrollView, StyleSheet, View, Text,
  FlexStyle,
} from 'react-native';
import PressableStyled, { PressableState } from './PressableStyled';
import PlusIcon from './16pxIcons/PlusIcon';
import Colors from '../constants/Colors';
import Style from '../constants/Style';
import { UserGroup } from '../constants/Types';

interface AddUserGroupButtonProps {
  disabled: boolean,
  selectedGroups: UserGroup[],
  userGroups: UserGroup[],
  addGroup: Dispatch<SetStateAction<UserGroup>>,
  style: FlexStyle,
  dropdownSelectionIndex: number | null,
  setDropdownSelectionIndex: Dispatch<SetStateAction<number | null>>,
}

const AddUserGroupButton = ({
  disabled, userGroups, addGroup, selectedGroups, style, dropdownSelectionIndex,
  setDropdownSelectionIndex,
}: AddUserGroupButtonProps) => {
  const selected: boolean = dropdownSelectionIndex === -1;

  return <View style={[styles.container, style]}>
    <PressableStyled
      onPress={() => setDropdownSelectionIndex(selected ? null : -1)}
      style={styles.addTagIcon}
      {...{ disabled }}
    >
      <PlusIcon color={Colors.light.hereworksDarkBlue} />
    </PressableStyled>
    <View>
      {selected && <ScrollView style={Style.dropdownMenu}>
        {userGroups
          .filter((userGroup: UserGroup) => !selectedGroups.includes(userGroup))
          .map((userGroup: UserGroup) => <View
            key={`user_group_option_${userGroup.UserGroupId}`}
            style={{}}
          >
            <Pressable
              style={({ hovered, pressed }: PressableState) => [
                Style.dropdownOption,
                hovered && Style.listItemHovered, pressed && Style.listItemPressed,
              ]}
              onPress={() => {
                addGroup(userGroup);
                setDropdownSelectionIndex(null);
              }}
            >
              <Text style={Style.dropdownText}>{userGroup.Name}</Text>
            </Pressable>
          </View>)}
      </ScrollView>}
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    width: 167,
  },
  addTagIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.light.hereworksDarkBlue,
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 2,
    zIndex: -10,
  },
});

export default AddUserGroupButton;
